import commonConfig from './index.common';
import specificConfig from './index.bbwm';

const config = {
    ...commonConfig,
    ...specificConfig
};

export default config;
